import React from "react";
import { Heart } from "lucide-react";
import { weddings } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Weddings({ onOpenImage }) {
  return (
    <section id="mariages" className="relative py-24 md:py-32 bg-[#F3E9DD]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="max-w-2xl mx-auto text-center mb-14 md:mb-20">
          <span className="inline-flex items-center gap-2 font-body text-xs tracking-luxe uppercase text-[#B0603F]">
            <Heart size={14} /> Projet
          </span>
          <h2 className="font-serif-display text-5xl md:text-7xl font-light text-[#3A302A] mt-4 leading-[1.15]">
            {weddings.title}
          </h2>
          <p className="mt-6 font-body text-[#6B5D53] leading-relaxed text-lg">{weddings.text}</p>
        </Reveal>

        {/* masonry-like gallery */}
        <div className="columns-2 md:columns-3 gap-4 md:gap-5 [column-fill:_balance]">
          {weddings.gallery.map((img, idx) => (
            <Reveal key={idx} className="mb-4 md:mb-5 break-inside-avoid">
              <button
                onClick={() => onOpenImage(weddings.gallery, idx)}
                className="hover-zoom rounded-2xl shadow-[0_18px_45px_-22px_rgba(58,48,42,0.45)] block w-full"
              >
                <img src={img} alt={`Mariage ${idx + 1}`} className="w-full h-auto object-cover" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
